/* TATOUT Clothing — theme behaviour.
   Vanilla, no dependencies, deferred. Everything degrades to a working
   server-rendered page if JavaScript fails. */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var strings = window.TATOUT_STRINGS || {};

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, window.TATOUT_MONEY_FORMAT);
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------- toast ---------------- */
  var toastEl = $('[data-toast]');
  function toast(msg) {
    if (!toastEl) return;
    $('[data-toast-t]', toastEl).textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('on'); }, 2600);
  }

  /* ---------------- overlays ---------------- */
  var openEl = null, lastFocus = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function openPanel(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (openEl && openEl !== el) closePanel();
    lastFocus = document.activeElement;
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    if (!el.classList.contains('modal')) { var s = $('[data-scrim]'); if (s) s.classList.add('on'); }
    document.body.classList.add('is-locked');
    openEl = el;
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () {
      var f = el.querySelector('input:not([type=hidden]),button,a[href]');
      if (f) f.focus();
    }, 60);
  }
  function closePanel() {
    if (!openEl) return;
    var id = openEl.id;
    openEl.classList.remove('on');
    openEl.setAttribute('aria-hidden', 'true');
    var s = $('[data-scrim]'); if (s) s.classList.remove('on');
    document.body.classList.remove('is-locked');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.TATOUT = { open: openPanel, close: closePanel, toast: toast };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openEl) { e.preventDefault(); closePanel(); return; }
    if (e.key === 'Tab' && openEl) {
      var f = $$(FOCUSABLE, openEl).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- cart ---------------- */
  function refreshCart(openAfter) {
    return fetch(routes + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]');
        var target = $('[data-cart-inner]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        return fetch(routes + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
        $$('[data-cart-count-txt]').forEach(function (n) { n.textContent = '(' + cart.item_count + ')'; });
        if (openAfter) openPanel('cart-drawer');
        document.dispatchEvent(new CustomEvent('tatout:cart:updated', { detail: cart }));
      })
      .catch(function () { toast(strings.cartError || 'Cart could not be updated. Refresh and try again.'); });
  }

  function addToCart(id, qty, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    return fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || strings.soldOut || 'That size is no longer available'); return; }
        toast(strings.added || 'Added to cart');
        return refreshCart(true);
      })
      .catch(function () { toast(strings.cartError || 'Cart could not be updated'); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }

  function changeLine(key, qty) {
    return fetch(routes + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(false); });
  }

  /* ---------------- wishlist (local, no app needed) ---------------- */
  var WKEY = 'tatout:wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wishSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} paintWish(); }
  function paintWish() {
    var w = wishGet();
    $$('[data-wl-count]').forEach(function (n) { n.textContent = w.length; n.hidden = !w.length; });
    $$('[data-wl-toggle]').forEach(function (b) {
      var on = w.indexOf(b.dataset.wlToggle) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var t = b.dataset.wlTitle || 'this item';
      b.setAttribute('aria-label', (on ? (strings.wlRemove || 'Remove {t} from wishlist') : (strings.wlAdd || 'Save {t} to wishlist')).replace('{t}', t));
    });
    var grid = $('[data-wishlist-grid]');
    if (grid) {
      $$('[data-wl-item]', grid).forEach(function (n) { n.hidden = w.indexOf(n.dataset.wlItem) < 0; });
      var any = w.length > 0;
      var empty = $('[data-wl-empty]');
      if (empty) empty.hidden = any;
      grid.hidden = !any;
    }
  }

  /* ---------------- recently viewed ---------------- */
  var RKEY = 'tatout:recent';
  function pushRecent(handle) {
    if (!handle) return;
    var r = [];
    try { r = JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) {}
    r = r.filter(function (h) { return h !== handle; });
    r.unshift(handle);
    try { localStorage.setItem(RKEY, JSON.stringify(r.slice(0, 8))); } catch (e) {}
  }
  function paintRecent() {
    var box = $('[data-recent]');
    if (!box) return;
    var r = [];
    try { r = JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) {}
    var current = box.dataset.recentExclude || '';
    r = r.filter(function (h) { return h !== current; }).slice(0, 4);
    if (r.length < 2) return;
    Promise.all(r.map(function (h) {
      return fetch(routes + 'products/' + h + '?section_id=product-card-ajax')
        .then(function (res) { return res.ok ? res.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).map(function (p) {
        var d = new DOMParser().parseFromString(p, 'text/html');
        var c = d.querySelector('.card');
        return c ? c.outerHTML : '';
      }).join('');
      if (!html) return;
      $('[data-recent-grid]').innerHTML = html;
      box.hidden = false;
      paintWish();
    });
  }

  /* ---------------- predictive search ---------------- */
  var searchInput = $('[data-predictive-input]');
  if (searchInput) {
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = searchInput.value.trim();
      var idle = $('[data-search-idle]'), out = $('[data-search-results]');
      if (q.length < 2) { if (idle) idle.hidden = false; if (out) { out.hidden = true; out.innerHTML = ''; } return; }
      timer = setTimeout(function () {
        fetch(routes + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article,page&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var d = new DOMParser().parseFromString(html, 'text/html');
            var res = d.querySelector('[data-predictive-inner]');
            if (idle) idle.hidden = true;
            if (out) { out.hidden = false; out.innerHTML = res ? res.innerHTML : ''; }
          })
          .catch(function () {});
      }, 200);
    });
  }

  /* ---------------- variant selection ---------------- */
  function initProductForm(form) {
    var data = $('[data-variants]', form);
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = $('[data-variant-id]', form);
    var priceEl = $('[data-price-target]');
    var atc = $('[data-atc-submit]', form);
    var stock = $('[data-stock]');

    function selected() {
      return $$('[data-option-index]', form).map(function (g) {
        var on = $('[aria-checked="true"]', g);
        return on ? on.dataset.value : null;
      });
    }
    function update() {
      var sel = selected();
      if (sel.indexOf(null) > -1) {
        if (atc) { atc.disabled = true; atc.textContent = strings.chooseSize || 'Select a size'; }
        return;
      }
      var v = variants.filter(function (x) {
        return x.options.every(function (o, i) { return o === sel[i]; });
      })[0];
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = strings.unavailable || 'Unavailable'; } return; }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = money(v.price) + ' ' + (window.TATOUT_CURRENCY || 'AUD');
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? (strings.addToCart || 'Add to cart') + ' — ' + money(v.price) : (strings.soldOut || 'Sold out');
      }
      if (stock) {
        stock.hidden = !v.available;
        var low = v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 8;
        stock.className = 'stock' + (low ? ' low' : '');
        stock.innerHTML = '<i></i>' + (low
          ? (strings.lowStock || 'Low stock — only {n} left').replace('{n}', v.inventory_quantity)
          : (strings.inStock || 'In stock, ships in 2–4 business days'));
      }
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
      $$('[data-sticky-var]').forEach(function (n) { n.textContent = sel.join(' · '); });
    }

    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-value]');
      if (!b || b.hasAttribute('disabled')) return;
      e.preventDefault();
      $$('[data-value]', b.closest('[data-option-index]')).forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
      b.setAttribute('aria-checked', 'true');
      var label = $('[data-option-label="' + b.closest('[data-option-index]').dataset.optionIndex + '"]');
      if (label) label.textContent = b.dataset.value;
      update();
    });

    form.addEventListener('submit', function (e) {
      if (!form.hasAttribute('data-ajax')) return;
      e.preventDefault();
      addToCart(idInput.value, +($('[data-qi]', form) || {}).value || 1, atc);
    });

    update();
  }
  $$('[data-product-form]').forEach(initProductForm);

  /* ---------------- global click delegation ---------------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openPanel(o.dataset.open); return; }
    if (e.target.closest('[data-close]') || e.target.closest('[data-scrim]')) { e.preventDefault(); closePanel(); return; }
    if (e.target.closest('[data-size-guide]')) { e.preventDefault(); openPanel('size-guide'); return; }

    var acc = e.target.closest('[data-acc],[data-fgrp],[data-sub]');
    if (acc) {
      e.preventDefault();
      var on = acc.getAttribute('aria-expanded') === 'true';
      acc.setAttribute('aria-expanded', String(!on));
      var panel = acc.nextElementSibling;
      if (panel) panel.classList.toggle('on', !on);
      return;
    }

    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart(qa.dataset.quickAdd, 1, qa); return; }

    var qv = e.target.closest('[data-quick-view]');
    if (qv) {
      e.preventDefault();
      var body = $('[data-qv-body]');
      body.innerHTML = '<div class="empty"><p class="meta">' + (strings.loading || 'Loading') + '…</p></div>';
      openPanel('quick-view');
      fetch(qv.dataset.quickView + '?section_id=quick-view-content')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          body.innerHTML = html;
          $$('[data-product-form]', body).forEach(initProductForm);
          paintWish();
        })
        .catch(function () { body.innerHTML = '<div class="empty"><p class="meta">' + (strings.qvError || 'Could not load this product. Open the full page instead.') + '</p></div>'; });
      return;
    }

    var wl = e.target.closest('[data-wl-toggle]');
    if (wl) {
      e.preventDefault();
      var id = wl.dataset.wlToggle, w = wishGet(), i = w.indexOf(id);
      if (i > -1) { w.splice(i, 1); toast(strings.wlRemoved || 'Removed from wishlist'); }
      else { w.push(id); toast(strings.wlSaved || 'Saved to wishlist'); }
      wishSet(w);
      return;
    }

    var minus = e.target.closest('[data-line-minus]');
    if (minus) { e.preventDefault(); changeLine(minus.dataset.lineMinus, +minus.dataset.qty - 1); return; }
    var plus = e.target.closest('[data-line-plus]');
    if (plus) { e.preventDefault(); changeLine(plus.dataset.linePlus, +plus.dataset.qty + 1); return; }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.lineRemove, 0); return; }

    if (e.target.closest('[data-qm]')) { var q = $('[data-qi]'); q.value = Math.max(1, +q.value - 1); return; }
    if (e.target.closest('[data-qp]')) { var q2 = $('[data-qi]'); q2.value = Math.min(99, +q2.value + 1); return; }

    var vt = e.target.closest('[data-view]');
    if (vt) {
      $$('[data-view]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      vt.setAttribute('aria-pressed', 'true');
      var grid = $('[data-product-grid]');
      if (grid) grid.classList.toggle('is-list', vt.dataset.view === 'list');
      try { localStorage.setItem('tatout:layout', vt.dataset.view); } catch (err) {}
      return;
    }

    if (e.target.closest('[data-top]')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    if (e.target.closest('[data-chat]')) { document.dispatchEvent(new CustomEvent('tatout:chat:open')); return; }

    var ann = e.target.closest('[data-close-ann]');
    if (ann) { var bar = $('#announcement'); if (bar) bar.hidden = true; try { sessionStorage.setItem('tatout:ann', '1'); } catch (err) {} return; }

    var ck = e.target.closest('[data-cookie]');
    if (ck) {
      var choice = ck.dataset.cookie;
      try { localStorage.setItem('tatout:consent', choice); } catch (err) {}
      $('#cookie-banner').classList.remove('on');
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: choice === 'all', marketing: choice === 'all', preferences: choice !== 'essential', sale_of_data: choice === 'all'
        }, function () {});
      }
      toast(choice === 'all' ? (strings.cookieAll || 'All cookies accepted') : (strings.cookieSaved || 'Preferences saved'));
      return;
    }
  });

  /* ---------------- quantity + line inputs ---------------- */
  document.addEventListener('change', function (e) {
    var li = e.target.closest('[data-line-qty]');
    if (li) { changeLine(li.dataset.lineQty, Math.max(0, +li.value || 0)); return; }
    var s = e.target.closest('[data-sort-select]');
    if (s) { s.form.submit(); return; }
    var f = e.target.closest('[data-facet-input]');
    if (f) { f.form.requestSubmit ? f.form.requestSubmit() : f.form.submit(); return; }
  });

  /* ---------------- header behaviour ---------------- */
  var hdr = $('#header'), lastY = 0;
  function onScroll() {
    var y = window.pageYOffset;
    if (hdr) {
      if (hdr.dataset.overlay === 'true') hdr.classList.toggle('is-over', y < 80);
      hdr.classList.toggle('is-hidden', y > lastY && y > 380 && !openEl);
    }
    var top = $('[data-top]'); if (top) top.classList.toggle('on', y > 700);
    var atc = $('[data-sticky-atc]'); if (atc) atc.classList.toggle('on', y > 420);
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------------- gallery counter ---------------- */
  var gal = $('[data-gal]');
  if (gal) {
    gal.addEventListener('scroll', function () {
      var total = gal.children.length;
      var i = Math.min(total, Math.round(gal.scrollLeft / gal.clientWidth) + 1);
      var c = $('[data-gal-count]');
      if (c) c.textContent = i + ' / ' + total;
    }, { passive: true });
  }

  /* ---------------- scroll reveal ---------------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------------- init ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    paintWish();
    var handle = document.body.dataset.productHandle;
    if (handle) pushRecent(handle);
    paintRecent();
    try {
      var layout = localStorage.getItem('tatout:layout');
      if (layout === 'list') { var b = $('[data-view="list"]'); if (b) b.click(); }
      if (sessionStorage.getItem('tatout:ann')) { var a = $('#announcement'); if (a) a.hidden = true; }
      if (!localStorage.getItem('tatout:consent')) {
        setTimeout(function () { var c = $('#cookie-banner'); if (c) c.classList.add('on'); }, 1500);
      }
    } catch (e) {}
    onScroll();
  });
})();
